import { get, find } from 'lodash-es'
import checkoutStepBase from '../checkoutStepBase'

import api from '../../api/checkout'

export default {
    mixins: [checkoutStepBase],

    data() {
        return {
            shippingMode: null,
            pickupPoint: this.checkoutData.userData.pickup_point_id,
            previouslySelectedPickupPoint: this.checkoutData.userData.pickup_point_id,
            errors: null
        }
    },

    created() {
        this.setInitialShippingMode()
    },

    watch: {
        shippingMode() {
            this.pickupPoint = this.hasPickupPoints
                ? this.previouslySelectedPickupPoint
                : null

            if ( this.shippingMode !== this.checkoutData.userData.shipping_mode ) {
                this.$bus.$emit('reset-selected-city')
            }
        }
    },

    computed: {
        defaultShippingModeId() {
            const defaultMode = this.checkoutData.shippingModes.find(shippingMode => shippingMode.isDefault)

            return defaultMode ? defaultMode.id : null
        },

        pickupPoints() {
            let results = this.getSelectedShippingMode(this.shippingMode, this.checkoutData.shippingModes)

            const points = get(results, 'pickupPoints', [])

            return points ? points : []
        },

        hasPickupPoints() {
            return this.pickupPoints.length
        },
        pickupPointComponent() {
            const shippingMode = this.getSelectedShippingMode(this.shippingMode, this.checkoutData.shippingModes)

            if (shippingMode && shippingMode.pickupPointComponent) {
                return shippingMode.pickupPointComponent
            }

            return 'pickup-point'
        }
    },

    methods: {
        getSelectedShippingMode: (shippingMode, shippingModes) => {
            const result = find(shippingModes, { id: shippingMode })

            return typeof result !== 'undefined'
                ? result
                : null
        },

        setPickupPoint(id) {
            this.pickupPoint = id
            this.previouslySelectedPickupPoint = id
        },

        async next() {
            try {
                const _shippingMode = {
                    'shipping_mode': this.shippingMode,
                }
                if ( this.hasPickupPoints && this.pickupPoint !== null ) {
                    _shippingMode['pickup_point_id'] = this.pickupPoint
                }
                await api.setShippingMode(_shippingMode)
                this.errors = null
                this.$bus.$emit('shipping-mode-saved', this.shippingMode)
                this.$bus.$emit('checkout-step-next')
            } catch (error) {
                if (error.response.status === 422) {
                    this.errors = error.response.data.errors
                }

                this.$bus.$emit('checkout-error', error)
            }
        },
        setInitialShippingMode() {
            this.shippingMode = this.checkoutData.userData.shipping_mode
                ? this.checkoutData.userData.shipping_mode
                : this.defaultShippingModeId
        }
    }
}
